import React from 'react';

const lazy = (factory) => React.lazy(factory);

export const AdminPages = {
  InactiveFlavoursRequest: lazy(() => import('../Pages/InactiveFlavoursRequest/InactiveFlavoursRequest')),
  InventoryHistory: lazy(() => import('../Pages/InventoryHistory/InventoryHistory')),
  InventoryHistoryView: lazy(() => import('../Pages/InventoryHistoryView/InventoryHistoryView')),
  MonthlyBalanceList: lazy(() => import('../Pages/MonthlyBalance/MonthlyBalanceList')),
  MonthlyBalanceView: lazy(() => import('../Pages/MonthlyBalance/MonthlyBalanceView')),
  MonthlyBalanceSetOpening: lazy(() => import('../Pages/MonthlyBalance/MonthlyBalanceSetOpening')),
  MonthlyPayments: lazy(() => import('../Pages/MonthlyPayments/MonthlyPayments')),
  DrinkPriceHistory: lazy(() => import('../Pages/DrinkPriceHistory/DrinkPriceHistory')),
  DisabledFlavourStatistics: lazy(() => import('../Pages/DisabledFlavourStatistics/DisabledFlavourStatistics')),
  MenuClicks: lazy(() => import('../Pages/MenuClicks/MenuClicks')),
  Promotions: lazy(() => import('../Pages/Promotions/Promotions')),
  HookahFlavors: lazy(() => import('../Pages/HookahFlavors/HookahFlavors')),
  FlavorDetails: lazy(() => import('../Pages/FlavorDetails/FlavorDetails')),
  HookahInventory: lazy(() => import('../Pages/HookahInventory/HookahInventory')),
  FlavourDeliveries: lazy(() => import('../Pages/FlavourDeliveries/FlavourDeliveries')),
  InventorySnapshot: lazy(() => import('../Pages/InventorySnapshot/InventorySnapshot')),
  Users: lazy(() => import('../Pages/Users/Users')),
  PublicUsers: lazy(() => import('../Pages/PublicUsers/PublicUsers')),
  PublicUserQrScanPage: lazy(() => import('../Pages/PublicUsers/PublicUserQrScanPage')),
  ShopManagement: lazy(() => import('../Pages/LoyaltyShop/ShopManagement')),
  HookahTypes: lazy(() => import('../Pages/HookahTypes/HookahTypes')),
  DailyHookahLogs: lazy(() => import('../Pages/DailyHookahLogs/DailyHookahLogs')),
  FailedHookahLogs: lazy(() => import('../Pages/FailedHookahLogs/FailedHookahLogs')),
  Roles: lazy(() => import('../Pages/Roles/Roles')),
  BrandsManagement: lazy(() => import('../Pages/BrandsManagement/BrandsManagement')),
  Categories: lazy(() => import('../Pages/Categories/Categories')),
  Drinks: lazy(() => import('../Pages/Drinks/Drinks')),
  AccountingTransactions: lazy(() => import('../Pages/Accounting/Transactions')),
  AccountingCategories: lazy(() => import('../Pages/Accounting/Categories')),
  AccountingReports: lazy(() => import('../Pages/Accounting/Reports')),
  HookahsPerDay: lazy(() => import('../Pages/Accounting/HookahsPerDay')),
  HookahsPerDayReport: lazy(() => import('../Pages/Accounting/HookahsPerDayReport')),
  CashBankTransfers: lazy(() => import('../Pages/CashBankTransfers/CashBankTransfers')),
  FeatureFlagsPage: lazy(() => import('../Pages/Admin/FeatureFlagsPage')),
  ApplicationLogs: lazy(() => import('../Pages/ApplicationLogs/ApplicationLogs')),
  TriggerReports: lazy(() => import('../Pages/Reports/TriggerReports')),
  MobileNotifications: lazy(() => import('../Pages/MobileNotifications/MobileNotifications')),
  BarTables: lazy(() => import('../Pages/BarTables/BarTables')),
  LoyaltyReservationsAdmin: lazy(() => import('../Pages/LoyaltyReservationsAdmin/LoyaltyReservationsAdmin')),
};

export const withSuspense = (Component) => (
  <React.Suspense fallback={<div className="app loading" role="status">Loading...</div>}>
    <Component />
  </React.Suspense>
);
